<ng-container *ngIf="devicesStore.isESSDevice$ | async">
  <app-feature-details-grid>
    <app-feature-list-container>
      <!-- ess.operationState -->
      <app-feature-list-item
        data-at-battery-state
        *ngIf="batteryOperationState$ | async | ready as feature"
        [error]="feature | error"
        [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE' | translate"
        [value]="feature | value2: featurePropertyKey.value | translateEssOperatingState"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>

      <!-- ess.power.consolidated for cascade device -->
      <app-feature-list-item
        data-at-battery-power
        *ngIf="
          (devicesStore.shouldUseConsolidatedFeature$ | async) &&
            (powerConsolidatedFeatures$ | async | ready) &&
            (powerConsolidatedPerDevice$ | async) as feature;
          else power
        "
        feature
        [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.POWER' | translate"
        value="{{ feature | featureLike | value2: featurePropertyKey.value }} {{
          feature | featureLike | unit: featurePropertyKey.value
        }}"
      >
      </app-feature-list-item>

      <!-- ess.power for single device -->
      <ng-template #power>
        <app-feature-list-item
          *ngIf="power$ | async | ready as feature"
          feature
          data-at-battery-power
          [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.POWER' | translate"
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>
      </ng-template>

      <!--  ess.stateOfCharge.consolidated for cascade device -->
      <app-feature-list-item
        data-at-battery-charge
        *ngIf="
          ((devicesStore.shouldUseConsolidatedFeature$ | async) &&
            (stateOfChargeConsolidatedFeatures$ | async) | ready) &&
            (stateOfChargeConsolidatedPerDevice$ | async) as feature;
          else stateOfCharge
        "
        feature
        [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE_OF_CHARGE' | translate"
        value="{{ feature | featureLike | value2: featurePropertyKey.value }} {{
          feature | featureLike | unit: featurePropertyKey.value
        }}"
      >
      </app-feature-list-item>
      <!-- ess.stateOfCharge for single device-->
      <ng-template #stateOfCharge>
        <app-feature-list-item
          data-at-battery-charge
          *ngIf="stateOfCharge$ | async | ready as feature"
          feature
          [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE_OF_CHARGE' | translate"
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        >
        </app-feature-list-item>
      </ng-template>

      <!-- ess.transfer.discharge.cumulated -->
      <app-feature-list-item
        data-at-battery-discharge-cumulated
        *ngIf="batteryDischargeCumulated$ | async | ready as feature"
        [error]="feature | error"
        [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.DISCHARGE_COUNTER' | translate"
        value="{{ feature | value2: featurePropertyKey.lifeCycle }} {{
          feature | unit: featurePropertyKey.lifeCycle
        }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
      <ng-container *ngIf="batteryCapacityConsolidated$ | async as batteryCapacityConsolidated">
        <app-feature-list-item
          *ngIf="!featureService.isFeatureConsolidate(batteryCapacityConsolidated)"
          data-at-battery-capacity-nominated
          [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.CAPACITY' | translate"
          value="{{
            batteryCapacityConsolidated | featureLike | value2: featurePropertyKey.value
          }} {{ batteryCapacityConsolidated | featureLike | unit: featurePropertyKey.value }}"
        >
        </app-feature-list-item>
        <app-feature-list-item
          *ngIf="featureService.isFeatureConsolidate(batteryCapacityConsolidated)"
          data-at-battery-capacity-nominated
          [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.CAPACITY' | translate"
          value="{{ batteryCapacityConsolidated | value2: featurePropertyKey.total }} {{
            batteryCapacityConsolidated | unit: featurePropertyKey.total
          }}"
        >
        </app-feature-list-item>
      </ng-container>
      <ng-container *ngIf="batteryCapacity$ | async as batteryCapacity">
        <app-feature-list-item
          data-at-battery-capacity-nominated
          [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.CAPACITY' | translate"
          value="{{ batteryCapacity | value2: featurePropertyKey.value }} {{
            batteryCapacity | unit: featurePropertyKey.value
          }}"
        >
        </app-feature-list-item>
      </ng-container>
    </app-feature-list-container>

    <ng-container *ngIf="batteries$ | async | ready as batteries">
      <ng-container *ngFor="let id of batteries.properties?.enabled?.value">
        <app-feature-list-container *ngIf="getBatteryFeature(id) | async | ready">
          <h3>
            {{
              '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.BATTERY_MODULE'
                | translate
            }}
            {{ id + 1 }}
          </h3>

          <!-- ess.battery.N.etn -->
          <app-feature-list-item
            *ngIf="getBatteryInternalComponents() | async | ready as batterySerialNumber"
            data-at-battery-serial-number
            id="battery-serial-number-box"
            [error]="batterySerialNumber | error"
            [label]="
              '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.SERIAL_NUMBER'
                | translate
            "
            [value]="(batterySerialNumber?.properties?.vinList?.value)[id]"
            [attr.data-feature]="batterySerialNumber.feature"
          >
          </app-feature-list-item>

          <!-- ess.battery.N.version.hardware -->
          <!--          <app-feature-list-item-->
          <!--            *ngIf="getBatteryHardwareRevision(id) | async | ready as batteryHardwareRevision"-->
          <!--            data-at-battery-hardware-version-box-->
          <!--            id="battery-hardware-version-box"-->
          <!--            [error]="batteryHardwareRevision | error"-->
          <!--            [label]="-->
          <!--              '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.HARDWARE_REVISION'-->
          <!--                | translate-->
          <!--            "-->
          <!--            [value]="batteryHardwareRevision | value: featurePropertyKey.value"-->
          <!--          >-->
          <!--          </app-feature-list-item>-->

          <!-- device.serial -->
          <app-feature-list-item
            *ngIf="devicesStore.getBatteryName(id) | async as batteryName"
            data-at-battery-manufacturer-name-box
            id="battery-serial-manufacturer-name-box"
            [error]="!batteryName"
            [label]="
              '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.TYPE' | translate
            "
            [value]="batteryName"
          >
          </app-feature-list-item>

          <!-- ess.battery.N.version.firmware -->
          <app-feature-list-item
            *ngIf="getBatteryFirmware(id) | async | ready as batteryFirmware"
            data-at-battery-firmware-box
            id="battery-firmware-box"
            [error]="batteryFirmware | error"
            [label]="
              '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.FIRMWARE'
                | translate
            "
            [value]="batteryFirmware | value2: featurePropertyKey.value"
            [attr.data-feature]="batteryFirmware.feature"
          >
          </app-feature-list-item>

          <ng-container *ngIf="authStore.isRsaUser()">
            <!-- ess.battery.N.information/stateOfHealth -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(id, BatteryInformationFeaturesType.stateOfHealth)
                  | async as batteryInformation
              "
              data-at-battery-state-of-health-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.STATE_OF_HEALTH'
                  | translate
              "
              value="{{ batteryInformation | featureLike | value2: featurePropertyKey.value }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
            </app-feature-list-item>

            <!-- ess.battery.N.information/countCoulombDisCharge -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.countCoulombDischarge
                ) | async as batteryInformation
              "
              data-at-battery-count-coulumb-discharge-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.COUNT_COULOMB_DISCHARGE'
                  | translate
              "
              value="{{ batteryInformation | featureLike | value2: featurePropertyKey.value }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
              <div class="w-full flex align-middle justify-between">
                <p>
                  {{
                    '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.COUNT_COULOMB_DISCHARGE'
                      | translate
                  }}
                </p>
                <!-- Unable to find the feature so not update unit yet. This value also is a number -->
                <p>{{ batteryInformation.value ?? NO_VALUE}}{{ batteryInformation.unit | unit }}</p>
              </div>
            </app-feature-list-item>

            <!-- ess.battery.N.information/cycleDischarge -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.cycleDischarge
                ) | async as batteryInformation
              "
              data-at-battery-cycle-discharge-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.CYCLES_DISCHARGE'
                  | translate
              "
              value="{{ batteryInformation.value | toInteger: true }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
            </app-feature-list-item>

            <!-- ess.battery.N.information/productionDate  -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.productionDate
                ) | async as batteryInformation
              "
              data-at-battery-production-date-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.PRODUCTION_DATE'
                  | translate
              "
              value="{{ batteryInformation.value | date: 'shortDate' | dash }}"
            >
            </app-feature-list-item>

            <!-- ess.battery.N.information/overTemperatureTime -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.overTemperatureTime
                ) | async as batteryInformation
              "
              data-at-battery-over-temperature-time-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.OVER_TEMPERATURE_TIME'
                  | translate
              "
              value="{{ batteryInformation | featureLike | value2: featurePropertyKey.value }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
            </app-feature-list-item>

            <!-- ess.battery.N.information/belowTemperatureTime -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.belowTemperatureTime
                ) | async as batteryInformation
              "
              data-at-battery-below-temperature-time-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.BELOW_TEMPERATURE_TIME'
                  | translate
              "
              value="{{ batteryInformation | featureLike | value2: featurePropertyKey.value }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
            </app-feature-list-item>

            <!-- ess.battery.N.information/overTemperatureWhileChargingTime -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.overTemperatureWhileChargingTime
                ) | async as batteryInformation
              "
              data-at-battery-over-temperature-while-charging-time-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.OVER_TEMPERATURE_WHILE_CHARGING_TIME'
                  | translate
              "
              value="{{ batteryInformation | featureLike | value2: featurePropertyKey.value }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
            </app-feature-list-item>

            <!-- ess.battery.N.information/belowTemperatureWhileChargingTime -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.belowTemperatureWhileChargingTime
                ) | async as batteryInformation
              "
              data-at-battery-below-temperature-while-charging-time-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.BELOW_TEMPERATURE_WHILE_CHARGING_TIME'
                  | translate
              "
              value="{{ batteryInformation | featureLike | value2: featurePropertyKey.value }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
            </app-feature-list-item>

            <!-- ess.battery.N.information/deepDischargeTime -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.deepDischargeTime
                ) | async as batteryInformation
              "
              data-at-battery-deep-discharge-time-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.DEEP_DEEP_DISCHARGE_TIME'
                  | translate
              "
              value="{{ batteryInformation | featureLike | value2: featurePropertyKey.value }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
            </app-feature-list-item>

            <!-- ess.battery.N.information/countEnergyDischarge -->
            <app-feature-list-item
              *ngIf="
                devicesStore.getBatteryInformation(
                  id,
                  BatteryInformationFeaturesType.countEnergyDischarge
                ) | async as batteryInformation
              "
              data-at-battery-count-energy-discharge-box
              [label]="
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.INFO_BATTERY_MODULES.COUNT_ENERGY_DISCHARGE'
                  | translate
              "
              value="{{ batteryInformation | featureLike | value2: featurePropertyKey.value }} {{
                batteryInformation | featureLike | unit: featurePropertyKey.value
              }}"
            >
            </app-feature-list-item>
          </ng-container>
        </app-feature-list-container>
      </ng-container>
    </ng-container>
  </app-feature-details-grid>
</ng-container>
